import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  border: none;
  margin: ${tokens.space.larger} 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const Legend = styled.legend`
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.l};
  line-height: ${tokens.lineHeights.l};
  color: ${tokens.colors.black};
  margin-bottom: ${tokens.space.large};
`;
